import dataSelect from "@store/dataForSelect/reducers";

import { topic_select } from "@Modules/Exams/configs/constants";

export default dataSelect(topic_select);
